import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { DownOutlined } from '@ant-design/icons';
import { Dropdown } from 'antd';
import { Button } from 'ui/styled';
export var DEFAULT_TITLE = 'Office Confidence';
var items = [0, 1, 2, 3, 4, 5].map(function (i) { return ({
    key: i,
    value: i,
    label: "".concat(i, "+")
}); });
var getTitleByKey = function (key) {
    var item = items.find(function (i) { return i.key.toString() === key; });
    if (!item)
        return DEFAULT_TITLE;
    return "".concat(DEFAULT_TITLE, ": ").concat(item.label);
};
var ConfidenceDropdown = function (_a) {
    var defaultValue = _a.defaultValue, onSelect = _a.onSelect, dataTest = _a.dataTest;
    var _b = useState(getTitleByKey(defaultValue)), title = _b[0], setTitle = _b[1];
    var onClick = function (item) {
        var key = item === null || item === void 0 ? void 0 : item.key;
        if (key === '0') {
            onSelect(undefined);
            setTitle(DEFAULT_TITLE);
        }
        else {
            onSelect(key);
            setTitle(getTitleByKey(key));
        }
    };
    return (_jsx(Dropdown, { menu: { items: items, onClick: onClick }, trigger: ['click'], children: _jsxs(Button, { "data-test": dataTest, children: [title, _jsx(DownOutlined, {})] }) }));
};
export default ConfidenceDropdown;
